import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './product.css'
import {message,TreeSelect} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import {SearchOutlined} from '@ant-design/icons';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;

class product extends React.Component {
  
  state={
    products:[],
    products2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    search:null,
    brand:null,
    influencer:null,
    interest:null,
    occasion:null,
    interests:[],
    occasions:[],
    brands:[],
    influencers:[]
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getBrands()
    this.getInfluencers()
    this.getInterests()
    this.getOccasions()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
    this.getProducts(1,true)

  }
  /**
   * 
   * get brands
  */
  getBrands = () => {
      axios.get(`${BASE_END_POINT}brands/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({brands:response.data.data})
      })
      .catch(error=>{
        console.log("ALL brands ERROR")
        console.log(error.response)
      })
  }
  /**
   * 
   * get influencers
  */
  getInfluencers = () => {
      axios.get(`${BASE_END_POINT}influencers/withoutPagenation/get`)
      .then(response=>{
          console.log(response.data)
          this.setState({influencers:response.data.data})
      })
      .catch(error=>{
          console.log("ALL influencers ERROR")
          console.log(error.response)
      })
  }
  /**
   * 
   * get occasions
  */
  getOccasions = () => {
      axios.get(`${BASE_END_POINT}occasion-suggestion/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({occasions:response.data.data})
      })
      .catch(error=>{
        console.log("ALL occasions ERROR")
        console.log(error.response)
      })
  }
  /**
   * 
   * get interests
  */
  getInterests = () => {
      axios.get(`${BASE_END_POINT}interests/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({interests:response.data.data})
      })
      .catch(error=>{
        console.log("ALL interests ERROR")
        console.log(error.response)
      })
  }

  /**
  * get data with pagenation request 
  */
  getProducts = (page,rest) =>{
    this.setState({loading:true})
    let url = `${BASE_END_POINT}products?page=${page}`
    let {interest,occasion,search,brand,influencer} = this.state
    if(interest !== null){
      let str = '&interest='+ interest
      url += str
    }
    if(brand !== null){
      let str = '&brand='+ brand
      url += str
    }
    if(influencer !== null){
      let str = '&influencer='+ influencer
      url += str
    }
    if(occasion !== null){
      let str = '&occasion='+ occasion
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}products?page=${page}`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("product   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.name,
        item.img?{type:"img",img:item.img}:{type:"img",img:null},
        item.price,
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        products:response.data.data,
        products2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  /**
  * delete request 
  */

  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}products/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getProducts(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
    })
 }

 /**
  * add new row component
  */
  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="Addproduct">
        <Fab
          style={{background:'#117183',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  /**
  * pagination Buttons component
  */
  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getProducts(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getProducts(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getProducts(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#117183 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getProducts(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getProducts(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PRODUCTS')) return <Redirect to='/Home' />


  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
            /**table settings contain reload and csv  */
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,brand:null,influencer:null,interest:null,occasion:null});this.getProducts(1,true)}}
                class="material-icons">
                  replay
                </span>
              </div>
              
            }
            /**table filter  */
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass':'hideClass'} style={{height:this.state.showFilter?"250px":"0px"}}>
                  <MDBRow>
                    <MDBCol md="4" sm="4">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.interests}</label>
                        <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.interests}
                            value={this.state.interest}
                            showCheckedStrategy= {SHOW_PARENT}
                            onChange={(value) => {
                                console.log(value)
                                this.setState({interest:value});
                            }} 
                        
                        >
                            {this.state.interests.map(val=>(
                                <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    <MDBCol md="4" sm="4">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasions}</label>
                        <TreeSelect virtual={false}
                            showSearch={false} 
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}         
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.occasions}
                            value={this.state.occasion}
                            showCheckedStrategy= {SHOW_PARENT}
                            onChange={(value) => {
                            console.log(value)
                            this.setState({occasion:value});
                            }} 
                        
                        >
                            {this.state.occasions.map(val=>(
                                <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    <MDBCol md="4" sm="4">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.brand}</label>
                        <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.brand}
                            value={this.state.brand}
                            showCheckedStrategy= {SHOW_PARENT}
                            onChange={(value) => {
                                console.log(value)
                                this.setState({brand:value});
                            }} 
                        
                        >
                            {this.state.brands.map(val=>(
                                <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    <MDBCol md="4" sm="4">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.influencer}</label>
                        <TreeSelect virtual={false}
                            showSearch={true}
                            disabled={this.state.actionType==="VIEW"?true:false}
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.influencer}
                            value={this.state.influencer}
                            showCheckedStrategy= {SHOW_PARENT}
                            onChange={(value) => {
                                console.log(value)
                                this.setState({influencer:value});
                            }} 
                        
                        >
                            {this.state.influencers.map(val=>(
                                <TreeNode value={val.id} title={val.fullname} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="8" lg="8" md="8" sm="12">
                      <div class="md-form">
                      <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.Search}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                  <MDBCol md="12">
                    <Button style={{background: '#117183',color: '#fff',width: '100%',margin: '32px auto'}} 
                      onClick={()=>{this.getProducts(1)}}><SearchOutlined /> {allStrings.Search}</Button>
                    </MDBCol>
                  </MDBRow>
                  
                </div>
              </div>
            }
            title={allStrings.products}
            icon='local_mall'
            data={this.state.products}
            data2={this.state.products2}
            tableColumns={["#",allStrings.name,allStrings.img,allStrings.price,allStrings.action]}
            loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/productInfo'
            actionIndex={5}
            />
            {this.paginationButtons()}
            {this.addNewRecordButton()}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(product)
);

